import axios from "axios";
import { ENDPOINTS } from "../../utils/APIEndpoints";
import { decryptData, encrypt } from "../../utils/encryption_decryption";
import { toast } from "react-toastify";
import axiosPrivate from "../../utils/axiosPrivate";
import { enCryptionFlag, LOCALSTORAGE } from "../../utils/constants";
import { getString } from "../../utils/storage";

export const loginUser = async (payload: any, token: any) => {
  try {
 
    var encryptdata: any =
      enCryptionFlag === true
        ? JSON.parse(encrypt(payload))
        : { data: payload };

    let loginType = getString(LOCALSTORAGE.LOGIN_TYPE, true)
  
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      LoginType: loginType,
    };
    const res = await axiosPrivate.post(
      `${globalThis._ENV_.REACT_APP_BASE_URL}${ENDPOINTS.LOGIN}`,
      encryptdata,
      { headers: headers },
    );
   
    if (res?.data?.RESULTLIST[0].FLAG === 1) {
      return res?.data;
    } else {
      return res?.data?.RESULTLIST[0].MSG;
    }
  } catch (error: any) {
    throw error;
  }
};

export const UserCheck = async (payload: any) => {
  try {
  
    var encryptdata: any =
      enCryptionFlag === true
        ? JSON.parse(encrypt(payload))
        : { data: payload };
    const res = await axiosPrivate.post(
      `${globalThis._ENV_.REACT_APP_BASE_URL}${ENDPOINTS.USERCHECK}`,
      encryptdata,
    );
   
    if (res?.data?.USER_DETAILS[0].FLAG === 1) {
      return res?.data;
    } else {
      return res?.data?.USER_DETAILS[0].USER_TYPE;
    }
  } catch (error: any) {
    throw error;
  }
};

export const getAccessTokenForlogin = async (payload: any) => {
  
  var encryptdata =
    enCryptionFlag === true ? JSON.parse(encrypt(payload)) : { data: payload };

  const res = await axios
    .post(
      `${globalThis._ENV_.REACT_APP_BASE_URL}${ENDPOINTS.GET_TOKEN}`,
      encryptdata,
    )
    .then(
      (res1: any) => {
       
        if (res1.status === 200) {
          return res1;
        }
      },
      (error: any) => {
        toast.error("Something Went Wrong");
      },
    );
  return res;
};

export const getRefreshTokenForlogin = async (payload: any) => {

  var encryptdata =
    enCryptionFlag === true ? JSON.parse(encrypt(payload)) : { data: payload };

  const res = await axios
    .post(
      `${globalThis._ENV_.REACT_APP_BASE_URL}${ENDPOINTS.GET_REFRESH_TOKEN_LOGIN}`,
      encryptdata,
    )
    .then(
      (res1: any) => {
        if (res1.status === 200) {
          return res1;
        }
      },
      (error: any) => {
        toast.error("Something Went Wrong");

        return false;
      },
    );
  return res;
};
